
import StringHelper from "@/utils/StringHelper";
import { Component, Vue } from "vue-property-decorator";

@Component
class PasswordChangeDialog extends Vue {
  password = "";
  confirmPassword = "";
  errorMessage = "";

  LoginMethod(): void {
    if (this.password === this.confirmPassword) {
      if (StringHelper.CheckPasswordComplexity(this.password)) {
        this.$store
          .dispatch("authenication/updatePassword", this.password)
          .then((result) => {
            this.$store.commit("authenication/showPasswordDialog", false);
          });
      } else {
        this.errorMessage = "The password did not meet the compliexity";
      }
    } else {
      this.errorMessage = "The passwords did not match";
    }
  }
}
export default PasswordChangeDialog;
